export default "__VITE_ASSET__bf6a13da__"